<ng-container *transloco="let t;">

  <div class="p-mb-4" [ngClass]="{'card-disabled': disabled === true }">
    <p-card>
      <h2>{{ t('common.labels.orderdata') }}</h2>

      <div class="p-grid">
        <div class="p-col-4">
          <app-form-control [cid]="'template'" [control]="form.get('orderdata.template')" [type]="'select'" [options]="templates" [filter]="true" optionLabel="name_language" [label]="t('common.labels.ac_type')" [edit]="inEdit" [basevalue]="getTemplateName()"></app-form-control>
        </div>
        <div class="p-col-4">
          <app-form-control [cid]="'dispatcher'" [control]="form.get('orderdata.dispatcher')" [type]="'select'" [options]="options?.dispatchers" optionLabel="fullname_reverse" [label]="t('common.labels.dispatcher')" [edit]="inEdit" [basevalue]="order?.dispatcher?.fullname_reverse" [filter]="true" [showClear]="true"></app-form-control>
        </div>
        <div class="p-col-4" *ngIf="lqgPositionVisible === true">
          <app-form-control [cid]="'lqgposition'" [control]="form.get('orderdata.lqgposition')" [type]="'select'" [options]="options?.lqg_positions" [label]="t('common.labels.lqgposition')" [edit]="inEdit" [basevalue]="getLqgPositionName()"></app-form-control>
        </div>
        <div class="p-col-4" *ngIf="tagVisible === true">
          <app-form-control [cid]="'tags'" [control]="form.get('orderdata.tags')" [type]="'multiselect'" [options]="tags" [label]="tagLabel || t('common.labels.tags')" [edit]="inEdit" [basevalue]="(order?.tags || []).join(',')"></app-form-control>
          <p *ngIf="tagDescription !== null" [innerHTML]="tagDescription | nl2br"></p>
        </div>
      </div>

      <div class="p-grid">
        <div class="p-col-4">
          <app-form-control [cid]="'location'" [control]="form.get('orderdata.location')" [type]="'select'" [options]="locations" optionLabel="name" [label]="t('common.labels.location')" [edit]="inEdit" [basevalue]="order?.location?.name || getOtherLocationName()" [filter]="true" [showClear]="true"></app-form-control>
        </div>
        <ng-container *ngIf="!isVirtual() && !isOtherLocation() && hasRooms()">
          <div class="p-col-4">
            <app-form-control [cid]="'room1'" [control]="form.get('orderdata.room1')" [type]="'select'" [options]="roomsMain" optionLabel="name" [label]="t('common.labels.room_main')" [edit]="inEdit" [basevalue]="getMainRoomName()" [filter]="true" [showClear]="true"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'room2'" [control]="form.get('orderdata.room2')" [type]="'select'" [options]="roomsPreparation" optionLabel="name" [label]="t('common.labels.room_preparation')" [edit]="inEdit" [basevalue]="getPreprationRoomName()" [filter]="true" [showClear]="true"></app-form-control>
          </div>
        </ng-container>
        <ng-container *ngIf="!hasRooms() && !isVirtual() && !isOtherLocation()">
          <div class="p-col-4">
            <app-form-control [cid]="'room_main'" [control]="form.get('orderdata.location_other.room_main')" [type]="'input'" [label]="t('common.labels.room_main')" [edit]="inEdit" [basevalue]="order?.location_other?.room_main" [placeholder]="t('common.labels.room_street_number')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'room_preparation'" [control]="form.get('orderdata.location_other.room_preparation')" [type]="'input'" [label]="t('common.labels.room_preparation')" [edit]="inEdit" [basevalue]="order?.location_other?.room_preparation" [placeholder]="t('common.labels.room_street_number')"></app-form-control>
          </div>
        </ng-container>
        <ng-container *ngIf="isVirtual() || isOtherLocation()">
          <div class="p-col-8">
            <app-country-timezone [required]="isVirtual()" [(country)]="country" [(timezone)]="timezone" [form]="form.get('orderdata.tz')" [edit]="inEdit"></app-country-timezone>
          </div>
        </ng-container>
        <ng-container *ngIf="isOtherLocation()">
          <div class="p-col-4">
            <app-form-control [cid]="'street'" [control]="form.get('orderdata.location_other.street')" [type]="'input'" [label]="t('common.labels.street')" [edit]="inEdit" [basevalue]="order?.location_other?.street"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'city'" [control]="form.get('orderdata.location_other.city')" [type]="'input'" [label]="t('common.labels.city')" [edit]="inEdit" [basevalue]="order?.location_other?.city"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'zip'" [control]="form.get('orderdata.location_other.zip')" [type]="'input'" [label]="t('common.labels.zip')" [edit]="inEdit" [basevalue]="order?.location_other?.zip"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'room_main'" [control]="form.get('orderdata.location_other.room_main')" [type]="'input'" [label]="t('common.labels.room_main')" [edit]="inEdit" [basevalue]="order?.location_other?.room_main"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'room_preparation'" [control]="form.get('orderdata.location_other.room_preparation')" [type]="'input'" [label]="t('common.labels.room_preparation')" [edit]="inEdit" [basevalue]="order?.location_other?.room_preparation"></app-form-control>
          </div>
          <div class="p-col-4"></div>
        </ng-container>
        <ng-container *ngIf="isVirtual()">
          <ng-container *ngIf="hasPrebriefing()">
            <div class="p-col-4">
              <app-form-control [cid]="'prebriefing_url'" [control]="form.get('orderdata.prebriefing_url')" [type]="'input'" [label]="t('common.labels.prebriefing_url')" [edit]="inEdit" [basevalue]="order?.prebriefing_url"></app-form-control>
            </div>
            <div class="p-col-4">
              <app-form-control [cid]="'prebriefing_info'" [control]="form.get('orderdata.prebriefing_info')" [type]="'input'" [label]="t('common.labels.prebriefing_info')" [edit]="inEdit" [basevalue]="order?.prebriefing_info"></app-form-control>
            </div>
            <div class="p-col-4"></div>
          </ng-container>
          <div class="p-col-4">
            <app-form-control [cid]="'conference_url'" [control]="form.get('orderdata.conference_url')" [type]="'input'" [label]="t('common.labels.conference_url')" [edit]="inEdit" [basevalue]="order?.conference_url"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'conference_info'" [control]="form.get('orderdata.conference_info')" [type]="'input'" [label]="t('common.labels.conference_info')" [edit]="inEdit" [basevalue]="order?.conference_info"></app-form-control>
          </div>
          <div class="p-col-4"></div>
        </ng-container>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-4">
          <app-form-control [cid]="'start_time'" [control]="form.get('orderdata.start_time')" [type]="'date'" [label]="t('common.labels.date') + getDstLabel()" [edit]="inEdit" [basevalue]="order?.start_time_admin | amDateFormat: 'DD.MM.YYYY - HH:mm'" [minDate]="minDate"></app-form-control>
        </div>
        <div class="p-col-4">
          <app-form-control [cid]="'until'" [control]="form.get('orderdata.until')" [type]="'input'" [label]="t('common.labels.until')" [edit]="inEdit" [basevalue]="form.get('orderdata.until').value"></app-form-control>
        </div>
        <div class="p-col-4">
          <app-form-control [cid]="'reportdate'" [control]="form.get('orderdata.reportdate')" [type]="'date'" [label]="t('common.labels.reportdate')" [showTime]="false" [edit]="inEdit" [basevalue]="order?.misc?.order?.reportdate | amDateFormat: 'DD.MM.YYYY'"></app-form-control>
        </div>
      </div>

      <hr />

      <div class="p-grid">
        <div class="p-col-6">
          <app-form-control [cid]="'informations_internal'" [control]="form.get('orderdata.informations_internal')" [type]="'textarea'" [label]="t('common.labels.informations_internal')" [edit]="inEdit" [basevalue]="order?.informations_internal"></app-form-control>
        </div>
        <div class="p-col-6">
          <app-form-control [cid]="'informations_moderator'" [control]="form.get('orderdata.informations_moderator')" [type]="'textarea'" [label]="t('common.labels.informations_moderator')" [edit]="inEdit" [basevalue]="order?.informations_moderator"></app-form-control>
        </div>
      </div>
    </p-card>
  </div>


</ng-container>
